module.exports = __webpack_public_path__ + "media/videos/testimonials/jessica-alba-h264-4d6e17659f1ef85cd17e71a0ff74db8c.mp4";